<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row :gutter="20" class="h-full">
      <el-col :span="24" class="h-full">
        <div class="mb-10px border-l-2 border-color-primary pl-10px">
          数据标准库:
        </div>
        <el-row class="flex items-center">
          <div class="inline-block">
            <el-select
              v-model="standardId"
              size="small"
              placeholder="请选择数据标准库"
              class="mr-10px"
              filterable
            >
              <el-option
                v-for="item in standardList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <selectTree
              :standardId="standardId"
              @selectNode="changeEntityData"
              ref="selectTree"
              class="mr-10px"
            />
            <el-select
              v-model="dataEntityName"
              size="small"
              placeholder="请选择数据表"
              filterable
              clearable
              :loading="entityLoading"
              class="mr-10px"
            >
              <el-option
                v-for="item in entityList"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
            <el-select
              size="small"
              v-model="isSpecial"
              class="mr-10px"
              clearable
              placeholder="请选择是否是特殊表头"
            >
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </div>

          <div class="inline-block">
            <el-button @click="getList" size="small" type="primary">搜索</el-button>
          </div>
        </el-row>
        <el-table
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          class="mt-20px"
          :height="`calc(100% - 140px)`"
          border
          stripe
          :data="tableList"
          ref="tableRef"
          v-loading="tableLoading"
        >
          <el-table-column
            prop="subjectName"
            label="业务分类"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="className" label="数据表" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="tableName"
            label="数据表代码"
            show-overflow-tooltip
            width="350px"
          ></el-table-column>
          <el-table-column
            prop="sourceSystem"
            label="来源系统"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="特殊表头" show-overflow-tooltip width="120px">
            <template slot-scope="scope">
              <el-switch
                @change="changeTemplateStatus(scope.row)"
                v-model="scope.row.isSpecial"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="数据审批" show-overflow-tooltip width="120px">
            <template slot-scope="scope">
              <el-switch
                @change="templateApprove(scope.row, scope.row.isNeedApprove)"
                v-model="scope.row.isNeedApprove"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220px">
            <template #default="{ row }">
              <el-button @click="clickTemplateDesign(row, 'view')" type="primary" size="mini"
                >预览</el-button
              >
              <el-button
                @click="clickTemplateDesign(row)"
                :type="row.templateId ? '' : 'primary'"
                size="mini"
                >编辑模板</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="mt-20px float-right"
          background
          @current-change="getList"
          @size-change="getList"
          :current-page.sync="page.pageNo"
          :page-sizes="[15, 30, 45, 60, 90, 100]"
          :page-size.sync="page.pageSize"
          :total="page.recordCount"
          layout="total, sizes, prev, pager, next"
        ></el-pagination>
      </el-col>
    </el-row>

    <el-dialog title="绑定/查看模板" :visible.sync="uploadVisible">
      <el-upload
        :show-file-list="true"
        :file-list="fileList"
        action="https://XX.YY.ZZ"
        class="text-center w-full h-full"
        drag
      >
        <i class="el-icon-upload" style="font-size: 67px"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
      </el-upload>
      <el-row class="text-center mt-10px">
        <el-button type="primary" size="small">保存</el-button>
        <el-button @click="clickCancel" size="small">取消</el-button>
      </el-row>
    </el-dialog>
  </el-card>
</template>

<script>
import StandardManagementService from '@/services/common/StandardManagementService'
import selectTree from './components/selectTree'

export default {
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 15,
        recordCount: 0,
      },
      treeData: [],
      defaultTreeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'isLeaf',
      },
      fileList: [],
      uploadVisible: false,
      standardList: [],
      standardId: '',
      isSpecial: null,
      standardBase: '',
      tableList: [],
      tableLoading: false, // 列表loading
      subjectId: '',
      dataEntityName: '', // 选择的数据实体name
      entityList: [], // 数据实体列表
      entityLoading: false, // 数据实体列表loading
      userInfo: Wiz.AuthHooks.GetUserInfo(), // 登录用户信息
    }
  },
  components: {
    selectTree,
  },
  async created() {
    await this.getStandardList()
    this.getEntityList()
    this.getList()
  },
  methods: {
    /**
     * @description 获取数据实体名称列表
     */
    async getEntityList() {
      if (!this.standardId) return
      this.entityLoading = true
      const res = await StandardManagementService.getEnityNameList({
        subjectId: this.subjectId,
        standardId: this.standardId,
      })
      this.entityLoading = false
      if (res && res.data && res.code === 0) {
        this.entityList = _.map(res.data, (item) => {
          return {
            name: item,
          }
        })
      }
    },

    /**
     * @description 启用/停止审批
     * @param {item:string}
     */
    async templateApprove(item, isValid) {
      if (!item.templateId) {
        item.isNeedApprove = !item.isNeedApprove
        this.$message.warnging('未绑定模板')
        return
      }
      if (!item.isNeedApprove) {
        this.$confirm('关闭后，实体将不进行采集审批，请确认是否继续', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await StandardManagementService.getTemplateApprove({
              templateId: item.templateId,
              isValid,
            })
            if (res?.code === 0) {
              this.$message.success('操作成功')
            }
          })
          .catch(() => {
            item.isNeedApprove = !item.isNeedApprove
          })
      } else {
        const res = await StandardManagementService.getTemplateApprove({
          templateId: item.templateId,
          isValid,
        })
        if (res?.code === 0) {
          this.$message.success('操作成功')
        }
      }
    },

    /**
     * @description 更换状态
     */
    async changeTemplateStatus(item) {
      if (item.templateId) {
        if (!item.isSpecial) {
          this.$confirm('关闭后，已有模板将被替换，请确认是否继续', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const res = await StandardManagementService.changeTemplateStatus({
                templateId: item.templateId,
                isValid: item.isSpecial,
              })
              if (res && res.code === 0) {
                this.$message.success('操作成功')
              }
            })
            .catch(() => {
              item.isSpecial = !item.isSpecial
            })
        } else {
          const res = await StandardManagementService.changeTemplateStatus({
            templateId: item.templateId,
            isValid: item.isSpecial,
          })
          if (res && res.code === 0) {
            this.$message.success('操作成功')
          }
        }
      } else {
        this.$message.warning('未绑定模板')
      }
    },

    changeEntityData(val) {
      this.subjectId = val
      this.getEntityList()
    },
    /**
     * @description 获取列表
     */
    async getList() {
      this.tableLoading = true
      const res = await StandardManagementService.geEntitytList({
        SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
        MaxResultCount: this.page.pageSize,
        subjectId: this.subjectId,
        standardId: this.standardId,
        isSpecial: this.isSpecial,
        className: this.dataEntityName,
      })
      this.tableLoading = false
      if (res && res.data && res.code === 0) {
        this.tableList = res.data
        this.page.recordCount = res.totalCount
        this.$nextTick(() => {
          this.$refs.tableRef?.doLayout()
        })
      }
    },

    // 获取标准库
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = res.data
        this.standardId = this.standardList[0]?.id
      }
    },
    /**
     * @description 点击模板设计
     */
    async clickTemplateDesign(item, type) {
      if (!type) {
        const tempData = await this.getTempData(item.classId, item.templateId)
        if (tempData) {
          this.$message.warning('当前模板存在暂存数据, 无法编辑')
          return
        }
      }
      this.$router.push({
        name: 'filling',
        query: {
          type,
          isSpecial: `${item.isSpecial}`,
          classId: item.classId,
          isValid: item.isSpecial,
          className: item.className,
          templateId: item.templateId,
          standardId: this.standardId,
          isNeedApprove: item.isNeedApprove,
        },
      })
    },

    /**
     * @description 临时数据查询
     * @param {String} classId 实体id
     * @param {String} templateId 模板id
     * @returns {Object} 临时数据
     */
    async getTempData(classId, templateId) {
      this.tableLoading = true
      const res = await StandardManagementService.getTempData({
        classId,
        templateId,
        collectUserId: this.userInfo?.profile?.sub,
      })
      this.tableLoading = false
      if (res && res.data && res.code === 0) {
        if (res.data.tempData) {
          return JSON.parse(res.data.tempData)
        }
      }
      return null
    },

    /**
     * @description 点击取消
     */
    clickCancel() {
      this.uploadVisible = false
    },

    clickUploadTemplate() {
      this.uploadVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
